/**
 * Deck / remote URL helpers (presentation iframe base, optional remote host override).
 */

export function resolveRemoteOrigin(): string {
  const revealEl = document.querySelector('.reveal');
  let override = String(
    revealEl?.getAttribute('data-remote-host') ||
      revealEl?.getAttribute('data-remote-origin') ||
      ''
  ).trim();
  if (!override && typeof (window as unknown as { __LECTURA_REMOTE_HOST__?: string }).__LECTURA_REMOTE_HOST__ === 'string') {
    override = String((window as unknown as { __LECTURA_REMOTE_HOST__?: string }).__LECTURA_REMOTE_HOST__ || '').trim();
  }
  if (!override) return window.location.origin;

  if (/^https?:\/\//i.test(override)) return override.replace(/\/+$/, '');
  const host = override.includes(':') || !window.location.port
    ? override
    : `${override}:${window.location.port}`;
  return `${window.location.protocol}//${host}`;
}

export function resolveDeckBasePath(): string {
  let path = window.location.pathname.replace(/\/+$/, '');
  const idx = path.lastIndexOf('/');
  if (idx >= 0 && path.substring(idx + 1) === 'index.html') {
    path = path.substring(0, idx);
  }
  return path || '/';
}
